export enum BarcodeTypes {
    EAN_13 = "EAN_13",
    DATA_MATRIX = "DATA_MATRIX"
}

export const barcodeTypeLabels: Record<BarcodeTypes, string> = {
    [BarcodeTypes.EAN_13]: "EAN-13",
    [BarcodeTypes.DATA_MATRIX]: "Data Matrix",
}
